// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluatePublicationFinderPage-cls1_Jg5","cls2":"EvaluatePublicationFinderPage-cls2_ew6 EvaluatePublicationFinderPage-cls1_Jg5"};